import { Box, CircularProgress, Typography, useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const ResellerUserRegistrationComponent = () => {
  const { showToast } = useToaster();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t: translate } = useTranslation();

  const windowURL = new URL(window.location.href);
  const urlParams = new URLSearchParams(windowURL.search);
  const registrationToken = urlParams.get('login_key');

  useEffect(() => {
    if (registrationToken) {
      checkForValidToken();
    } else {
      showToast(translate('reseller_register.token_not_found', 'Token not found. Please contact administrator'), 'e');
      navigate('/login');
    }
  }, []);

  const checkForValidToken = () => {
    let postProps = {
      token: registrationToken,
      device_type: isMobile ? CommonHelper.DeviceType.Mobile : CommonHelper.DeviceType.Desktop,
    }
    const tokenProps = {
      url: `${userModuleURL.checkResellerTokenIsValid}?token=${registrationToken}`,
      body: postProps,
      successCallback: successCallback,
      failureCallback: failureCallback,
    };
    HttpServices.Post(tokenProps);
  };

  const failureCallback = (message) => {
    showToast(message, 'e');
  };

  const successCallback = (data, message) => {
    data['is_register'] = true;
    data['is_reseller'] = true;
    CommonHelper.AppLoginCall(data);
  };

  return (
    <Box sx={{ textAlign: 'center', mt: 5 }}>
      <CircularProgress size={60} sx={{ mb: 3 }} />
      <Typography variant="body2" color="textSecondary" gutterBottom>
        {translate('reseller_register.please_wait', 'Please wait while we the registeration in progress.')}
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        {translate('reseller_register.do_not_refresh', 'Do not refresh or close this page.')}
      </Typography>
    </Box>
  );
};

export default ResellerUserRegistrationComponent;
